// TODO: slide direction; calculate if the option list has enough space to
// expand bewteen end of viewport and dropdown

( function( global ) { // eslint-disable-line
    var pluginName = 'grDropdown';

    var config = {
        trigger: '[gr-dropdown-trigger]',
        target: '[gr-dropdown-target]'
    }

    if (Array.prototype.contains === undefined) {
        // attach the .contains method to Array's prototype to call it on any array
        Array.prototype.contains = function (thing) {
            if (!this) return false; // if the other array is a falsy value, return false
            var result = false; // start by assuming the array doesn't contain the thing
            for (var i = 0, l=this.length; i < l; i++) {
                if (this[i] instanceof Array) { // if anything in the array is the thing then change our mind from before
                    if (this[i].equals(thing)) result = true;
                } else if (this[i]===thing) result = true;
            }
            return result; //return the decision
        }
    }

    // Constructor
    function grDropdown( selector, options ) {
        // Merge defaults with user's settings
        this.config = global.methods.objectAssign(config, options);

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        // Get elements
        this.trigger = this.selector.querySelector(this.config.trigger);
        this.target = this.selector.querySelector(this.config.target);

        // Retrieve plugin custom parameters
        this.params = this.selector.getAttribute('gr-dropdown').split(' ');

        this.init();
    }

    grDropdown.prototype.init = function init() {
        if (this.selector === null) {
            throw new Error(pluginName + ': fail - something wrong with your selector');
        } else {
            // ready
            this.ready = true;
            global.methods.toggleAttributeValue(this.selector, 'gr-dropdown', 'ready');
            if (groots.verbose) console.log(pluginName + '(' + this.selector + '): ready');

            // binding
            var arr = [
                'handleClick',
                'handleDocumentClick',
                'handleMouseEnter',
                'handleMouseLeave',
                'handleAnimationEnd',
                'handleAnimationStart'
            ];

            for (var i = 0, len = arr.length; i < len; i++) {
                var method = arr[i];
                this[method] = this[method].bind(this);
            }

            // addEventListener
            if ('ontouchstart' in document === false && this.params.contains('hover')) {
                this.selector.addEventListener('mouseenter', this.handleMouseEnter);
                this.selector.addEventListener('mouseleave', this.handleMouseLeave);
            } else {
                this.trigger.addEventListener('click', this.handleClick);
                document.addEventListener('click', this.handleDocumentClick);
            }

            this.target.addEventListener('animationstart', this.handleAnimationStart);
            this.target.addEventListener('animationend', this.handleAnimationEnd);
        }
    };

    // Destroy - remove listeners to prevent from memory leak
    grDropdown.prototype.destroy = function destroy() {
        if (groots.verbose) console.log(pluginName + ': destroyed');
        global.methods.removeAttributeValue(this.selector, 'gr-dropdown', 'ready active');

        if ('ontouchstart' in document === false && this.params.contains('hover')) {
            this.selector.removeEventListener('mouseenter', this.handleMouseEnter);
            this.selector.removeEventListener('mouseleave', this.handleMouseLeave);
        } else {
            this.trigger.removeEventListener('click', this.handleClick);
            document.removeEventListener('click', this.handleDocumentClick);
        }

        this.target.removeEventListener('animationstart', this.handleAnimationStart);
        this.target.removeEventListener('animationend', this.handleAnimationEnd);
    };

    grDropdown.prototype.moveTarget = function moveTarget() {
        if (groots.verbose) console.log(pluginName + ' moveTarget');
        this.params = this.selector.getAttribute('gr-dropdown').split(' ');
        this.isOpen = this.params.contains('active') ? false : true;
        global.methods.toggleAttributeValue(this.selector, 'gr-dropdown', 'active', true);

        if (this.isOpen) {
            global.methods.removeAttributeValue(this.selector, 'gr-dropdown', 'slide-out');
            global.methods.toggleAttributeValue(this.selector, 'gr-dropdown', 'slide-in');
        } else {
            global.methods.removeAttributeValue(this.selector, 'gr-dropdown', 'slide-in');
            global.methods.toggleAttributeValue(this.selector, 'gr-dropdown', 'slide-out');
        }
    };

    grDropdown.prototype.handleAnimationStart = function handleAnimationStart() {
        if (groots.verbose) console.log(pluginName + ' animationstart');
        global.methods.toggleAttributeValue(this.selector, 'gr-dropdown', 'animating');
    };

    grDropdown.prototype.handleAnimationEnd = function handleAnimationEnd() {
        if (groots.verbose) console.log(pluginName + ' animationend');
        global.methods.removeAttributeValue(this.selector, 'gr-dropdown', 'animating');
        global.methods.removeAttributeValue(this.selector, 'gr-dropdown', 'slide-out');
        global.methods.removeAttributeValue(this.selector, 'gr-dropdown', 'slide-in');
    };

    grDropdown.prototype.handleClick = function handleClick() {
        if (groots.verbose) console.log(pluginName + ' click');
        this.moveTarget();
    };

    grDropdown.prototype.handleMouseEnter = function handleMouseEnter() {
        if (groots.verbose) console.log(pluginName + ' mouseenter');
        this.moveTarget();
    };

    grDropdown.prototype.handleMouseLeave = function handleMouseLeave() {
        if (groots.verbose) console.log(pluginName + ' mouseleave');
        this.moveTarget();
    };

    grDropdown.prototype.handleDocumentClick = function handleDocumentClick(event) {
        this.params = this.selector.getAttribute('gr-dropdown').split(' ');

        if (event.target.contains(this.selector) && this.params.contains('active')) {
            if (groots.verbose) console.log(pluginName + ' clicked outside');
            this.moveTarget();
        }
    };

    // jQuery wrapper, if available
    if (window.jQuery) {
        $.fn[pluginName] = function (options) {
            options = options || config;
            return this.each(function() {
                // add plugin to element data
                if (!$.data(this, pluginName) ) $.data(this, pluginName, new grDropdown(this, options));
            });
        };
    }

    // Auto-Instantiation
    var all = {}, index;
    if (document.querySelectorAll('[gr-dropdown]').length) {
        window.groots.grDropdown = { instances: {} };
        all = document.querySelectorAll('[gr-dropdown]');
        index = -1;
        while (all[++index])
            global.grDropdown.instances[index] = new grDropdown(all[index]);
    }

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = grDropdown;
    // Export to Browser
    else global[pluginName] = grDropdown; // eslint-disable-line

}( window.groots ));
